module.exports = __webpack_public_path__ + "static/img/ls20.48ca604.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls20.png
// module id = vbXp
// module chunks = 12